class RiskService {
  constructor(publicKey) {
    this.publicKey = publicKey;
    this.riskInstance = null;
    this.initializing = null;
  }

  async init() {
    if (this.riskInstance) {
      return this.riskInstance;
    }

    if (this.initializing) {
      return this.initializing;
    }

    if (typeof window === "undefined" || !window.Risk) {
      return null;
    }

    this.initializing = window.Risk.create(this.publicKey)
      .then((risk) => {
        this.riskInstance = risk;
        return risk;
      })
      .finally(() => {
        this.initializing = null;
      });

    return this.initializing;
  }

  async getSessionId() {
    try {
      const risk = await this.init();

      if (!risk) {
        return null;
      }

      const sessionId = await risk.publishRiskData();

      if (typeof sessionId !== "string") {
        return null;
      }

      return sessionId;
    } catch (e) {
      return null;
    }
  }
}

export default RiskService;
